<template>
        <div class="wrapper">
          <div  class="contact">
          <h1>KONTAKT</h1>
          <p>Molimo Vas da obezbedite dole tražene informacije, </p>
          <p><strong>odgovorićemo u najkraćem mogućem roku</strong> </p>

          <p>* Obavezna polja</p>
          <p></p>
          <div class="topic">
            <label class="" for="topic">NASLOV *</label>
            <select class="" name="topic" v-model="user.topic">
              <!-- <option value="Odaberite naslov"  selected="selected" disabled="" >Odaberite naslov</option> -->
              <option value="Proizvodi">Proizvodi</option>
              <option value="Nakon kupovine">Nakon kupovine</option>
              <option value="Distribucija">Distribucija</option>
              <option value="UsluŽna proizvodnja">Uslužna proizvodnja </option>
              <option value="Ostalo">Ostalo</option>
            </select>
          </div>
          <div class="personal">
            <div class="prefix">
              <label class="" for="prefix">PREFIX *</label>
              <select class="" id="prefix" name="" v-model="user.prefix" autofocus>
                <!-- <option value=""  selected="selected" disabled="disabled" >Odaberite prefix</option> -->
                <option value="G-đica">Gđica</option>
                <option value="G-đa">Gđa</option>
                <option value="G-din">Gdin</option>

              </select>
            </div>
          <div class="name">
            <label class="" for="name">IME *</label>
            <input  class="" id="name" v-model="user.ime" type="text" required>
          </div>
          <div class="prezime">
            <label class="" for="prezime">PREZIME *</label>
            <input  class="" id="prezime" v-model="user.prezime" type="text" required >
          </div>

          </div>
          <div class="textarea">
            <label class="" for="prefix">TEKST PORUKE *</label>
            <textarea name="name" rows="8" cols="80" v-model="user.message"></textarea>
          </div>

          <div class="email">
            <label class="" for="email">E-MAIL *</label>
            <input  class="" id="" v-model="user.email" type="text" required >
          </div>
          <!-- <div class="newsletter">
            <div class="newstext">
              Prijavi se da primaš obaveštenja o promocijama i novostima
            </div>

            <label class="checkbox">
               <input v-model ="news" type="checkbox" id="" value="" @click="" />&nbsp
               <span class="checkmark"></span>
            </label>
          </div> -->
          <div class="errors">
            <p>&nbsp<span>{{errors}}</span></p>
          </div>

          <button  class="bigbutton" type="button" name="button" @click="DeleveryData ()" title="Click and get products">POŠALJI ></button>

          </div>
          <div class="prazan" >
      			<br>
      			<br>
      		</div>
        </div>

</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';

export default {

  data () {
    return {
      errors:"",
      user:{
        ime:null,
        prezime:null,
        message:null,
        topic:null,
        prefix:null,
        email:null

      },
      news:false

    }
  },

  computed:{
    ...mapGetters([
        'getsid',
        'lang'
    ]),


  },
  methods:{
    ...mapActions([
      'checksession',
      'contact',
      'contacteng'
    ]),
    async DeleveryData () {
      this.errors = null
      const areAllFieldsFilledIn = Object
        .keys(this.user)
        .every(key => !!this.user[key])
      if (!areAllFieldsFilledIn) {
        this.errors = 'Molimo Vas da popunite sva obavezna polja *'
        return
      }

      try {
        this.errors = null
        var now = new Date().toLocaleString();
        if(this.news){
          this.user.news = true
        }
        this.user.time = now
        if(this.lang == "eng"){
          this.contacteng(this.user)
        }
        if(this.lang == "srb"){
          this.contact(this.user)
        }

        alert('Hvala na interesovanju,Odgovorićemo Vam u najkraćem mogućem roku')
        this.$router.push("/")


      } catch (err) {
        console.log(err)
      }
    },

},

  mounted(){
    // this.checksession(this.getsid)
    document.getElementById('myheader').scrollIntoView();
    window.scroll(0,0);
  }
}
</script>


<style scoped>
  .wrapper {
    margin-top:140px;
    float: none;
    text-align: center;
  }


</style>



// WEBPACK FOOTER //
// src/components/contact.vue